import { createContext, useContext } from 'react';
import { EICFConsentStatus } from '../../../entities/EICFConsents/EICFConsent.ts';

export type EICFPendingStatus =
  | typeof EICFConsentStatus.PendingPatientSignature
  | typeof EICFConsentStatus.PendingPhysicianSignature
  | null;

export interface EICFConsentLockValue {
  isLocked: boolean;
  pendingStatus: EICFPendingStatus;
  consentId: number | null;
}

export const EICFConsentLockContext = createContext<EICFConsentLockValue>({
  isLocked: false,
  pendingStatus: null,
  consentId: null,
});

export const useEICFConsentLock = (): EICFConsentLockValue =>
  useContext(EICFConsentLockContext);
